<template>
  <div>
    <callout v-if="!hasReplacement" type="warning" v-html="bp('archiveNoReplacement')" />
    <div v-else>
      <callout type="success" icon="check_circle" v-html="bp('archiveReplacement')" />
      <trek-button primary block @click="navigateToReplacement">
        <span v-html="bp('archiveViewCurrent')" />
      </trek-button>
    </div>
  </div>
</template>
<script>
import get from 'lodash/get';
import {Url} from '@/utils/url';
import Callout from '@/components/Callout';
import TrekButton from '@/components/TrekButton';

export default {
  name: 'PdpReplacement',
  components: {TrekButton, Callout},
  props: {
    replacementProduct: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    sku() {
      return get(this.replacementProduct, 'sku');
    },
    url() {
      const url = get(this.replacementProduct, 'url');
      return !url ? '' : Url.withContextPath(url);
    },
    hasReplacement() {
      return this.sku && this.url;
    },
  },
  methods: {
    navigateToReplacement() {
      window.location.href = this.url;
    },
  },
};
</script>
